import React from 'react';
import clsx from 'clsx';
import { BoltIcon } from '@heroicons/react/24/outline';

export const ProLabel = (props: {
  tooltip?: string;
  className?: string;
  variant?: 'default' | 'emphasis';
}) => {
  const [showTooltip, setShowTooltip] = React.useState(false);
  const variant = props.variant ?? 'default';

  return (
    <div
      className={clsx(
        'relative inline-flex items-center gap-1 rounded-md px-2 mx-2 text-[0.625rem]',
        variant === 'emphasis'
          ? 'bg-primary-700 text-white dark:bg-primary-600'
          : 'bg-neutral-100 dark:bg-neutral-700 text-neutral-500 dark:text-neutral-400',
        props.className
      )}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <BoltIcon
        className={clsx(
          'size-3',
          variant === 'emphasis' ? 'text-white' : 'text-yellow-500 dark:text-yellow-400'
        )}
      />
      <span
        className={clsx(
          'font-heading font-medium uppercase',
          variant === 'emphasis' ? 'text-white' : 'text-neutral-700 dark:text-neutral-300'
        )}
      >
        Pro
      </span>
      {showTooltip && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-neutral-900 text-white text-xs rounded shadow-lg whitespace-nowrap z-50">
          {props.tooltip || 'Only available on the Pro plan'}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-neutral-900"></div>
        </div>
      )}
    </div>
  );
};
